// Главное меню — Hero + группы услуг в iOS-стиле (как AI Office).

import { ServiceCard } from "../components/ServiceCard";

export default function Home() {
  return (
    <div className="min-h-[100dvh] pb-10">
      {/* Hero */}
      <div className="px-5 pt-8 pb-2 text-center">
        <div className="mx-auto w-24 h-24 rounded-full overflow-hidden shadow-lg mb-4 bg-gradient-to-br from-[var(--accent)] to-[#7a0c1e] flex items-center justify-center">
          <img
            src="/avatar.png"
            alt="Антон Короткий"
            className="w-full h-full object-cover"
            onError={(e) => {
              // Если /avatar.png ещё не загружен — показываем буквы «АК» поверх градиента.
              const img = e.currentTarget;
              img.style.display = "none";
              const parent = img.parentElement;
              if (parent && !parent.querySelector(".fallback")) {
                const span = document.createElement("span");
                span.className = "fallback text-3xl text-white font-bold";
                span.textContent = "АК";
                parent.appendChild(span);
              }
            }}
          />
        </div>
        <div className="text-[26px] font-bold text-ink tracking-tight">Антон Короткий</div>
        <div className="text-[14px] text-muted mt-1">Привет 👋 Выбери, с чем пришёл</div>
      </div>

      {/* Stat strip — социальные доказательства */}
      <div className="px-5 mt-5">
        <div className="grid grid-cols-3 gap-3">
          <div className="stat-tile">
            <div className="text-[22px] font-bold text-ink">18</div>
            <div className="text-[11px] text-muted leading-tight mt-0.5">лет в бизнесе</div>
          </div>
          <div className="stat-tile">
            <div className="text-[22px] font-bold text-ink">7K+</div>
            <div className="text-[11px] text-muted leading-tight mt-0.5">участников форумов</div>
          </div>
          <div className="stat-tile">
            <div className="text-[22px] font-bold text-ink">90K</div>
            <div className="text-[11px] text-muted leading-tight mt-0.5">подписчиков</div>
          </div>
        </div>
      </div>

      {/* Группа 1 — Личная работа со мной */}
      <div className="section-header">Личная работа со мной</div>
      <div className="px-5">
        <div className="ios-group">
          <ServiceCard
            to="/advisory-board"
            icon="💼"
            title="Advisory Board"
            subtitle="Внешний адвайзер для собственника"
            color="indigo"
          />
          <ServiceCard
            to="/marketing"
            icon="📈"
            title="Маркетинг-консалтинг"
            subtitle="Разовая консультация или стратегия"
            color="blue"
          />
          <ServiceCard
            to="/event-consulting"
            icon="🎤"
            title="Эвент-консалтинг"
            subtitle="Запуск масштабных форумов"
            color="pink"
          />
          <ServiceCard
            to="/time-management"
            icon="🕘"
            title="Тайм-менеджмент «Как у Антона»"
            subtitle="3 встречи: время, цели, ассистент"
            color="orange"
          />
          <ServiceCard
            to="/automation"
            icon="🤖"
            title="Автоматизация бизнеса"
            subtitle="Боты, AI-ассистенты, кастомные системы"
            color="purple"
          />
        </div>
      </div>

      {/* Группа 2 — Продукт */}
      <div className="section-header">Система финансового учёта для малого бизнеса</div>
      <div className="px-5">
        <div className="ios-group">
          <ServiceCard
            to="/finkeeper"
            icon="💰"
            title="FinKeeper"
            subtitle="Финансовый учёт для малого бизнеса"
            color="green"
          />
        </div>
      </div>

      {/* Группа 3 — Бали (порядок: аренда → Cocoon → RESIDE) */}
      <div className="section-header">Недвижимость на Бали</div>
      <div className="px-5">
        <div className="ios-group">
          <ServiceCard
            to="/bali/villa-rent"
            icon="🏖"
            title="Снять виллу для отдыха / жизни"
            subtitle="Чангу, Семиньяк, Улувату, Убуд"
            color="mint"
          />
          <ServiceCard
            to="/bali/cocoon"
            icon="🌿"
            title="Стать акционером Cocoon Resort"
            subtitle="Wellness-отель, средний ROI 19,5%"
            color="brown"
          />
          <ServiceCard
            to="/bali/reside"
            icon="🏝"
            title="Инвестиции в недвижимость"
            subtitle="RESIDE — 15–20% годовых"
            color="teal"
          />
        </div>
      </div>

      {/* Группа 4 — Другое */}
      <div className="section-header">Другое</div>
      <div className="px-5">
        <div className="ios-group">
          <ServiceCard
            to="/instagram-ads"
            icon="📣"
            title="Реклама в Instagram"
            subtitle="@anton.karotki — 90 000+ подписчиков"
            color="red"
          />
          <ServiceCard
            to="/partnership"
            icon="🤝"
            title="Предложить партнёрство"
            subtitle="Бартер, коллаборация, идея"
            color="yellow"
          />
        </div>
      </div>

      {/* Группа 5 — О человеке */}
      <div className="section-header">Обо мне</div>
      <div className="px-5">
        <div className="ios-group">
          <ServiceCard
            to="/about"
            icon="👤"
            title="Биография и проекты"
            subtitle="6 проектов, регалии, путь"
            color="blue"
          />
          <ServiceCard
            to="/links"
            icon="🔗"
            title="Соцсети и сайты"
            subtitle="Instagram, Telegram, RESIDE, FinKeeper"
            color="indigo"
          />
        </div>
      </div>

      {/* Подвал */}
      <div className="text-center text-[12px] text-muted px-8 mt-8 leading-relaxed">
        Все заявки приходят мне лично. Часть из них дополнительно обрабатывает мой ассистент Алёна.
        Свяжемся в течение дня.
      </div>
    </div>
  );
}
